import { RouteObject } from "react-router";
import { Outlet } from 'react-router-dom';

import App from "./App";
import ROUTES from "./constants/routes.json";
import { SettingsScreen, ROUTE as AccountSettingsScreenRoute } from "./screens/settings/settingsScreen";
import { Dashboard } from "./screens/dashboard/dashboard";
import { Error404 } from "./screens/error/error404";
import { HomeScreen, ROUTE as HomeScreenRoute } from "./screens/homeScreen";
import { Login } from "./screens/login";
import { UserProfile } from "./screens/user/userProfile";
import PartnersScreen, { PartnersRoute } from "./screens/partners/partnersScreen";
import PartnerDetailsScreen from "./screens/partners/partnerDetailsScreen";
import PartnerEditScreen from "./screens/partners/partnerEditScreen";
import { SettingsFieldsScreen } from "./screens/settings/fieldsScreen";
import { SettingsFieldScreen } from "./screens/settings/fieldScreen";
import { LabelsScreen } from "./screens/settings/labelsScreen";
import ProjectsScreen, { ProjectsRoute } from "./screens/projects/projectsScreen";
import ProjectEditScreen from "./screens/projects/projectEditScreen";
import ProjectDetailsScreen from "./screens/projects/projectDetailsScreen";
import ResourcesScreen, { ResourcesRoute } from "./screens/resources/resourcesScreen";
import ProjectResourcesScreen from "./screens/projects/projectResourcesScreen";
import ResourceDetailsScreen from "./screens/resources/resourceDetailsScreen";
import ResourceEditScreen from "./screens/resources/resourceEditScreen";
import ProjectResourceEditScreen from "./screens/projectResources/editScreen";
import ReviewsScreen, { ReviewsRoute } from "./screens/reviews/reviewsScreen";
import UsersScreen from "./screens/settings/usersScreen";
import UserEditScreen from "./screens/settings/userEditScreen";
import ProjectReviewerEditScreen from "./screens/projects/projectReviewerEditScreen";
import ReviewEditScreen from "./screens/reviews/reviewEditScreen";
import ReviewDetailsScreen from "./screens/reviews/reviewDetailsScreen";
import TagsScreen from "./screens/settings/tagsScreen";
import TagEditScreen from "./screens/settings/tagEditScreen";
import TagDetailsScreen from "./screens/settings/tagScreen";
import { TodoReviewsScreen } from "./screens/todo/todoReviewsScreen";
import UnitEvaluationsScreen, { UnitEvaluationsRoute } from "./screens/unitEvaluations/unitEvaluationsScreen";
import UnitEvaluationsDetailsScreen from "./screens/unitEvaluations/unitEvaluationsDetailsScreen";
import UnitEvaluationEditScreen from "./screens/unitEvaluations/unitEvaluationEditScreen";
import UserDetailsScreen from "./screens/settings/userDetailsScreen";
import UnitReportScreen from "./screens/reports/unitReportScreen";
import HeatmapReportScreen from "./screens/reports/heatMapScreen";
import ResourceQualityReportScreen from "./screens/reports/resourceQualityReport";
import CoherencyReportScreen from "./screens/reports/coherencyReport";
import ProjectFlatFileScreen from "./screens/projects/projectFlatFile";
import TagExportScreen from "./screens/settings/tagExport";
import ShareApp from "./ShareApp";
import ProjectShareScreen from "./screens/projects/projectShareScreen";
import SharedHeatmapScreen from "./screens/anonymous/sharedHeatmapScreen";
import SharedProjectScreen from "./screens/anonymous/sharedProjectScreen";
import SharedUnitScreen from "./screens/anonymous/sharedUnitScreen";
import SharedResourceQualityScreen from "./screens/anonymous/sharedResourceQuality";
import SharedCoherencyScreen from "./screens/anonymous/sharedCoherency";
import ReviewDeleteScreen from "./screens/reviews/reviewDeleteScreen";
import SurveysScreen from "./screens/surveys/surveysScreen";
import SurveyDetailsScreen from "./screens/surveys/surveyDetailsScreen";
import SurveyMetricScreen from "./screens/surveys/surveyMetricScreen";
import SurveyReportScreen from "./screens/surveys/surveyReportScreen";
import SurveyQuestionScreen from "./screens/surveys/surveyQuestionScreen";
import SurveyStakeholderEditScreen from "./screens/surveys/surveyStakeholderEditScreen";
import SurveyEditScreen from "./screens/surveys/surveyEditScreen";
import OCMPReportScreen from "./screens/reports/ocmpReportScreen";
import SurveyDataScreen from "./screens/surveys/surveyDataScreen";
import SurveyStakeholderDetailsScreen from "./screens/surveys/surveyStakeholderDetailsScreen";
import SurveyReportPublishScreen from "./screens/surveys/surveyReportPublishScreen";
import SharedSurveyReportScreen from "./screens/anonymous/sharedSurveyReportScreen";
import ResourceDeleteScreen from "./screens/resources/resourceDeleteScreen";
import TagDeleteScreen from "./screens/settings/tagDeleteScreen";
import ProjectCloneScreen from "./screens/projects/projectCloneScreen";
import SurveyReportProgressScreen from "./screens/surveys/surveyReportProgressScreen";
import ResourcesSearchScreen from "./screens/resources/resourcesSearchScreen";
import ProjectDeleteScreen from "./screens/projects/projectDelete";
import ProjectEditGradeScreen from "./screens/projects/projectEditGradeScreen";
import ExportsScreen from "./screens/settings/exportsScreen";
import SurveyImportSettingsScreen from "./screens/surveys/surveyImportSettingsScreen";

const Routes: RouteObject[] = [
	{
		path: '*',
		element: <Error404 />
	},
	{ path: ROUTES.LOGIN, element: <Login /> },
	{
		element: <ShareApp />,
		path: '/share/:shareKey',
		children: [
			{
				element: <SharedProjectScreen />,
				path: "project",
			},
			{
				element: <SharedHeatmapScreen />,
				path: "heatmap",
			},
			{
				element: <SharedUnitScreen />,
				path: "unit",
			},
			{
				element: <SharedCoherencyScreen />,
				path: "coherency",
			},
			{
				element: <SharedResourceQualityScreen />,
				path: "resourceQuality",
			},
			{
				element: <SharedSurveyReportScreen />,
				path: "surveyReport",
			},

		]
	},
	{
		element: <App />,
		//path: '',
		children: [

			{
				path: HomeScreenRoute,
				element: <HomeScreen />
			},
			{
				path: ROUTES.DASHBOARD,
				element: <Outlet />,
				children: [
					// { path: 'all-work', element: <AllWorkScreen /> },
					{ path: 'reviews', element: <TodoReviewsScreen /> },
					// { path: 'unitEvaluations', element: <DashboardReviewsScreen /> },
					{ index: true, element: <Dashboard /> },
				]
			},
			{
				path: AccountSettingsScreenRoute,
				element: <SettingsScreen />
			},
			{
				path: 'surveys',
				element: <Outlet />,
				children: [
					// specific Survey
					{
						path: ':surveyId',
						element: <Outlet />,
						children: [
							{
								path: 'question',
								element: <Outlet />,
								children: [
									{ path: ':surveyQuestionId/edit', element: <SurveyQuestionScreen /> },
								]
							},
							{
								path: 'report',
								element: <Outlet />,
								children: [
									{ path: ':surveyReportId/edit', element: <SurveyReportScreen /> },
									{ path: ':surveyReportId/publish', element: <SurveyReportPublishScreen /> },
									{ path: ':surveyReportId/progress', element: <SurveyReportProgressScreen /> },
									{ path: 'create', element: <SurveyReportScreen /> },
								]
							},
							{
								path: 'stakeholder',
							 element: <Outlet />,
								children: [
									{ path: ':surveyStakeholderId/edit', element: <SurveyStakeholderEditScreen /> },
									{ path: 'create', element: <SurveyStakeholderEditScreen /> },
									{ path: ':surveyStakeholderId/details', element: <SurveyStakeholderDetailsScreen /> },
									{ path: ':parentSurveyStakeholderId/create', element: <SurveyStakeholderEditScreen /> },
								]
							},
							{
								path: 'metric',
								element: <Outlet />,
								children: [
									{ path: ':surveyMetricId/edit', element: <SurveyMetricScreen /> },
									{ path: 'create', element: <SurveyMetricScreen /> },
								]
							},
							{ path: 'import-settings', element: <SurveyImportSettingsScreen /> },
							{ path: 'edit', element: <SurveyEditScreen /> },
							{ index: true, element: <SurveyDetailsScreen /> },
						]
					},
					{ path: 'data', element: <SurveyDataScreen /> },
					{ index: true, element: <SurveysScreen /> },
				]
			},
			{
				path: PartnersRoute,
				element: <Outlet />,
				children: [
					{ path: 'details/:id', element: <PartnerDetailsScreen /> },
					{ path: 'edit/:id', element: <PartnerEditScreen /> },
					{ path: 'create', element: <PartnerEditScreen /> },
					{ index: true, element: <PartnersScreen /> },
				]
			},
			{
				path: ProjectsRoute,
				element: <Outlet />,
				children: [
					{ path: ':projectId/reviewers/:id/edit', element: <ProjectReviewerEditScreen /> },
					{ path: ':projectId/reviewers/create', element: <ProjectReviewerEditScreen /> },
					{ path: ':projectId/resources/:id/edit', element: <ProjectResourceEditScreen /> },
					{ path: ':projectId/resources', element: <ProjectResourcesScreen /> },
					{ path: ':id/clone', element: <ProjectCloneScreen /> },
					{ path: ':id/share', element: <ProjectShareScreen /> },
					{ path: ':id/export', element: <ProjectFlatFileScreen /> },
					{ path: ':id/edit', element: <ProjectEditScreen /> },
					{ path: ':id/edit/grade/:grade', element: <ProjectEditGradeScreen /> },
					{ path: ':id/delete', element: <ProjectDeleteScreen /> },
					{ path: 'create', element: <ProjectEditScreen /> },
					{ path: ':id', element: <ProjectDetailsScreen /> },
					{ index: true, element: <ProjectsScreen /> },
				]
			},
			{
				path: ResourcesRoute,
				element: <Outlet />,
				children: [
					{ path: ':id', element: <ResourceDetailsScreen /> },
					{ path: ':id/edit', element: <ResourceEditScreen /> },
					{ path: ':id/delete', element: <ResourceDeleteScreen /> },
					{ path: 'create', element: <ResourceEditScreen /> },
					{ path: 'search', element: <ResourcesSearchScreen /> },
					{ index: true, element: <ResourcesScreen /> },
				]
			},
			{
				path: ReviewsRoute,
				element: <Outlet />,
				children: [
					{ path: ':id', element: <ReviewDetailsScreen /> },
					{ path: ':id/edit', element: <ReviewEditScreen /> },
					{ path: ':id/delete', element: <ReviewDeleteScreen /> },
					{ path: 'create', element: <ReviewEditScreen /> },
					{ index: true, element: <ReviewsScreen /> },
				]
			},
			{
				path: UnitEvaluationsRoute,
				element: <Outlet />,
				children: [
					{ path: ':id', element: <UnitEvaluationsDetailsScreen /> },
					{ path: ':id/edit', element: <UnitEvaluationEditScreen /> },
					{ path: 'create', element: <UnitEvaluationEditScreen /> },
					{ index: true, element: <UnitEvaluationsScreen /> },
				]
			},
			{
				path: '/user',
				element: <Outlet />,
				children: [
					{ path: 'profile', element: <UserProfile /> },
				]
			},
			{
				path: '/reports',
				element: <Outlet />,
				children: [
					{ path: 'heatmap', element: <HeatmapReportScreen /> },
					{ path: 'unit', element: <UnitReportScreen /> },
					{ path: 'resourceQuality', element: <ResourceQualityReportScreen /> },
					{ path: 'coherency', element: <CoherencyReportScreen /> },
					{ path: 'ccmp', element: <OCMPReportScreen /> },
				]
			},
			{
				path: 'settings/*',
				element: <Outlet />,
				children: [
					{
						path: 'users', element: <Outlet />, children: [
							{ path: ':id/details', element: <UserDetailsScreen /> },
							{ path: ':id/edit', element: <UserEditScreen /> },
							{ path: 'create', element: <UserEditScreen /> },
							{ index: true, element: <UsersScreen /> },
						]
					},
					{
						path: 'fields', element: <Outlet />, children: [
							{ path: 'edit/:id', element: <SettingsFieldScreen /> },
							{ path: 'create', element: <SettingsFieldScreen /> },
							{ index: true, element: <SettingsFieldsScreen /> },
						]
					},
					{
						path: 'tags', element: <Outlet />, children: [
							{ path: ':parentTagId/create', element: <TagEditScreen /> },
							{ path: ':id', element: <TagDetailsScreen /> },
							{ path: ':id/delete', element: <TagDeleteScreen /> },
							{ path: ':id/edit', element: <TagEditScreen /> },
							{ path: ':id/export', element: <TagExportScreen /> },
							{ path: 'create', element: <TagEditScreen /> },
							{ index: true, element: <TagsScreen /> },
						]
					},
					{ path: 'labels', element: <LabelsScreen /> },
					{ path: 'export', element: <ExportsScreen /> },
					{ index: true, element: <SettingsScreen /> },
				]
			},
		]
	},

];

export default Routes;